import * as React from 'react';
import DotLoader from 'react-spinners/DotLoader';
interface Props {
  loading: boolean;
}

export const LoadingIndicator = (props: Props) => (
  <DotLoader {...props} size={50} color="#225828" />
);
